import { render, staticRenderFns } from "./StakingNew.vue?vue&type=template&id=3d7bde52"
import script from "./StakingNew.vue?vue&type=script&lang=js"
export * from "./StakingNew.vue?vue&type=script&lang=js"
import style0 from "./StakingNew.vue?vue&type=style&index=0&id=3d7bde52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports